<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  title: {
    type: String,
    required: false,
  },
  openAtCreated: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'sm',
    validator: value => ['sm', 'md', 'lg', 'xl'].includes(value),
  },
  iconSubtitle: {
    type: Boolean,
    default: false,
  },
  hideHeader: {
    type: Boolean,
    default: false,
  },
})

const active = ref(false)

onMounted(() => {
  if (props.openAtCreated) {
    active.value = true
  }
})

const toggle = () => {
  active.value = !active.value
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <div
      class="border-neutral-30 flex w-full cursor-pointer flex-row items-center justify-between border-b py-1"
      @click="toggle"
      :class="{
        hidden: hideHeader,
      }"
    >
      <h4
        class="font-medium"
        :class="{
          'text-xs': size === 'sm',
          'text-base': size === 'md',
          'text-lg': size === 'lg',
          'text-[22px]': size === 'xl',
        }"
      >
        <slot name="title">
          {{ title }}
        </slot>
      </h4>
      <div class="flex flex-row items-center gap-2">
        <p v-if="iconSubtitle" class="text-primary-90 text-sm">
          {{ active ? 'Recolher' : 'Expandir' }}
        </p>
        <ImoIcon
          name="arrow-down-02"
          :size="16"
          class="transition-transform duration-300 ease-in-out"
          :class="{ 'rotate-90': active }"
        />
      </div>
    </div>
    <div
      class="transition-all duration-300 ease-in-out"
      :class="{ 'flex flex-col': active, hidden: !active }"
    >
      <slot />
    </div>
  </div>
</template>
